(function() {

    'use strict';



    var XML2 = SAPO.Utility.XML2;



    var toBool = function(s) { return (s.toLowerCase() === 'true'); };
    var toInt = function(s) { return parseInt(s, 10); };
    var identity = function(s) { return s; };



    var fetchPair = function(el, prop1, prop2, castFn) {
        if (castFn) { castFn = identity; }

        var val1 = el.getAttribute(prop1);
        if (val1) {
            val1 = castFn(val1);
        }

        var val2 = el.getAttribute(prop2);
        if (val2) {
            val2 = castFn(val2);
        }

        if (val1 && val2) {
            return [val1, val2];
        }
    };



    function StaticResourceParser(el) {

        // required
        var item = {
            nodeName: el.nodeName,
            src:      XML2.text(el), // element content
            type:     el.getAttribute('creativeType').toLowerCase()
        };



        // from elsewhere (Companion)
        var tmp, parentEl = el.parentNode;

        tmp = fetchPair(parentEl, 'width', 'height', toInt);
        if (tmp) { item.dims = tmp; }

        tmp = fetchPair(parentEl, 'assetWidth', 'assetHeight', toInt);
        if (tmp) { item.assetDims = tmp; }

        tmp = fetchPair(parentEl, 'expandedWidth', 'expandedHeight', toInt);
        if (tmp) { item.expandedDims = tmp; }

        tmp = parentEl.getAttribute('apiFramework');
        if (tmp) { item.apiFramework = tmp; }

        tmp = parentEl.getAttribute('id');
        if (tmp) { item.id = tmp; }

        tmp = parentEl.getAttribute('adSlotId');
        if (tmp) { item.adSlotId = tmp; }



        tmp = XML2.getText(parentEl, 'CompanionClickThrough');
        if (tmp) { item.companionClickThrough = tmp; }



        // from elsewhere (NonLinear)
        if (parentEl.getAttribute('maintainAspectRatio')) {
            item.maintainAspectRatio = toBool( parentEl.getAttribute('maintainAspectRatio') );
        }

        if (parentEl.getAttribute('scalable')) {
            item.scalable = toBool( parentEl.getAttribute('scalable') );
        }

        var minSuggestedDuration = parentEl.getAttribute('minSuggestedDuration');
        if (minSuggestedDuration) {
            item.minSuggestedDuration = XML2.parseTime( minSuggestedDuration );
        }

        return item;
    }



    SAPO.Project.Video.VAST.parsers.StaticResource = StaticResourceParser;

})();
